import { render, staticRenderFns } from "./formTextarea.vue?vue&type=template&id=6589ebd4"
import script from "./formTextarea.vue?vue&type=script&lang=js"
export * from "./formTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports